// header Side menu js Start
var Shopify = Shopify || {};
Shopify.money_format = '$';
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
function customUpdateQuantity(id, quantity, openCart)
{
    let formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', quantity);

    fetch("/cart/change.js",
        {
            body: formData,
            method: "post"
        })
        .then(response => response.json())
        .then((response) => {
            if(response.status == "bad_request")
            {
                alert(response.description);
            }
            else
            {
                if(response.token != "undefined" && response.token != null && response.token != "")
                {
                     ajaxCartCall(openCart);
                }
            }
        })
        .catch(function(error) {
          alert(error);
        });
}
function miniCartRefresh(openCart) 
{   
    fetch('/cart?view=minicart')
    .then(response => response.text())
        .then((response) => {
            document.querySelector(".side-cart .cart_content").innerHTML = response;
            if(openCart)
            {
                var sideCart = document.querySelector('.side-cart');
                var body = document.querySelector('body');
                body.classList.add('overlay');
                sideCart.classList.add('show');
            }
            if(document.querySelectorAll('.side-cart__content li'))
            {
                document.querySelectorAll('.side-cart__content li').forEach(selector => {
                    var removeSelector = selector.querySelector('.right-product-content .cart-remove-product');
                    removeSelector.addEventListener('click', function(event) {
                        event.preventDefault();
                        var itemKey = event.target.closest('.product-box').getAttribute("data-key");
                        customUpdateQuantity(itemKey, 0, false);
                    });
                    var quantityInputSelector = selector.querySelector('.right-product-content .qty input');
                    quantityInputSelector.addEventListener('change', function(event) {
                        event.preventDefault();
                        var inputValue = this.value;
                        var itemKey = event.target.closest('.product-box').getAttribute("data-key");
                        customUpdateQuantity(itemKey, inputValue, false);
                    });
                    var minusSelector = selector.querySelector('.right-product-content .qty .qtyminus');
                    minusSelector.addEventListener('click', function(event) {
                        event.preventDefault();
                        var parentQuantity = this.parentElement;
                        var quantityInput = parentQuantity.querySelector("input");
                        var quantityInputValue = quantityInput.value;
                        quantityInputValue = parseInt(quantityInputValue) - 1;
                        if(quantityInputValue < 0)
                        {

                        }
                        else
                        {
                            quantityInput.value = quantityInputValue;
                            quantityInput.dispatchEvent(new Event('change'));
                        }
                    });
                    var plusSelector = selector.querySelector('.right-product-content .qty .qtyplus');
                    plusSelector.addEventListener('click', function(event) {
                        event.preventDefault();
                        var parentQuantity = this.parentElement;
                        var quantityInput = parentQuantity.querySelector("input");
                        var quantityInputValue = quantityInput.value;
                        quantityInputValue = parseInt(quantityInputValue) + 1;
                        if(quantityInputValue < 0)
                        {

                        }
                        else
                        {
                            quantityInput.value = quantityInputValue;
                            quantityInput.dispatchEvent(new Event('change'));
                        }
                    });
                });
            }
        })
        .catch(function(error) {
          console.log(error);
        });
}
function ajaxCartCall(openCart)
{
    fetch('/cart.js')
    .then(response => response.json())
        .then((response) => {
            if(typeof response.item_count != "undefined")
            {
                if(document.querySelectorAll(".cart-link .badge"))
                {
                    var headerCountBoxs = document.querySelectorAll('.cart-link .badge');
                    headerCountBoxs.forEach(selector => {
                        selector.innerHTML = response.item_count;
                        if(response.item_count > 0)
                        {
                            document.querySelector('.side-cart .cart_content').classList.remove("empty_cart");
                        }
                        else
                        {
                            document.querySelector('.side-cart .cart_content').classList.add("empty_cart");
                        }
                    });
                    miniCartRefresh(openCart);
                }
            }
        })
        .catch(function(error) {
          console.log(error);
        });
}
function ajaxAddToCart(variantId, quantity, openCart)
{
    let formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    fetch("/cart/add.js",
        {
            body: formData,
            method: "post"
        })
        .then(response => response.json())
        .then((response) => {
            if(response.status == "bad_request")
            {
                alert(response.description);
            }
            else
            {
                if(response.id)
                {
                    ajaxCartCall(openCart);
                }
            }
        })
        .catch(function(error) {
          alert(error);
        });
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelectorAll('.custom-sorting-filter ul li')) 
    {
        var customSortingLi = document.querySelectorAll('.custom-sorting-filter ul li');
        customSortingLi.forEach(selector => {
            var customSortingLiATag = selector.querySelector("a");
            customSortingLiATag.addEventListener('click', function (event) {
                event.preventDefault();
                var matchAttribute = this.getAttribute("data-value");
                var defaultSortingList = document.querySelector('#SortBy');
                for (var option of defaultSortingList.options) {
                    option.removeAttribute("selected");
                }
                for (var option of defaultSortingList.options) {
                    var selectedValue = option.getAttribute("value");
                    if(matchAttribute == selectedValue)
                    {
                        var matchAttributeValue = option.getAttribute("value");
                        defaultSortingList.value = matchAttributeValue;
                        option.setAttribute("selected", "selected");
                        document.querySelector(".facets__form").submit();

                    }
                }
            });
        });
    }
    var openCart = getUrlParameter('open_cart');
    if(typeof openCart != "undefined" && openCart != null && openCart != "" && openCart == "true")
    {
        ajaxCartCall(true);
    }
    if(document.querySelectorAll('.js-select-radio')) 
    {
        var customRadioBox = document.querySelectorAll('.js-select-radio');
        customRadioBox.forEach(selector => {
            selector.addEventListener('change', function (newSelector) {
                var parentRow = newSelector.target.closest('.single-product-option').parentElement;
                var productForm = newSelector.target.closest('.single-product-option').parentElement.parentElement;
                var productOptionsLists = parentRow.querySelectorAll('.single-product-option');
                var selectedValue = "";
                if (productOptionsLists) 
                {
                    productOptionsLists.forEach(function (el, key) {
                        if(el.querySelectorAll('.color-variant-list li'))
                        {
                            var currentValue = "";
                            var customSingleRadioBox = el.querySelectorAll('.color-variant-list li');
                            customSingleRadioBox.forEach(function (newElement, newKey) {
                                if(newElement.querySelector('.js-select-radio').checked) 
                                {
                                    currentValue = newElement.querySelector('.js-select-radio').value;
                                }
                            });
                            if(currentValue)
                            {
                                if(key > 0)
                                {
                                    selectedValue += " / "+currentValue;
                                }
                                else
                                {
                                    selectedValue += currentValue;
                                }
                            }
                        }
                    });
                }
                if(selectedValue)
                {
                    var productvariantsLists = productForm.querySelector('.js-actual-product-variants');
                    if(productvariantsLists)
                    {
                        for (var option of productvariantsLists.options) {
                            option.removeAttribute("selected");
                        }
                        var isVariantMatched = false;
                        for (var option of productvariantsLists.options) {
                            var matchAttribute = option.getAttribute("data-match");
                            if(matchAttribute == selectedValue)
                            {
                                var matchAttributeValue = option.getAttribute("value");
                                productvariantsLists.value = matchAttributeValue;
                                option.setAttribute("selected", "selected");
                                isVariantMatched = true;
                                productvariantsLists.dispatchEvent(new Event('change'));
                            }
                        }
                        if(!isVariantMatched)
                        {
                            var productBoxWrapper = newSelector.target.closest('.single-product-option').parentElement.parentElement.parentElement;
                            var addToCartButtonEnableText = productBoxWrapper.querySelector(".btn-add-to-cart").getAttribute("data-atc-text");
                            var addToCartButtonDisableText = productBoxWrapper.querySelector(".btn-add-to-cart").getAttribute("data-oos-text");
                            productBoxWrapper.querySelector(".btn-add-to-cart").setAttribute("disabled", "disabled");
                            productBoxWrapper.querySelector(".btn-add-to-cart").innerHTML = addToCartButtonDisableText;
                            productBoxWrapper.querySelector(".btn-add-to-cart").style.display = "none";
                        }
                    }
                }
            });
        });
    }
    if(document.querySelector('.product-form .js-actual-product-variants'))
    {
        document.querySelector('.product-form .js-actual-product-variants').addEventListener('change', function(event) {
            var variantAvailable = this.options[this.selectedIndex].getAttribute('data-available');
            var variantIsSalePrice = this.options[this.selectedIndex].getAttribute('data-is-sale-price');
            var variantSalePrice = this.options[this.selectedIndex].getAttribute('data-old-price');
            var variantOriginalPrice = this.options[this.selectedIndex].getAttribute('data-sale-price');
            var variantImageName = this.options[this.selectedIndex].getAttribute("data-image-name");
            var variantId = this.options[this.selectedIndex].getAttribute("value");
            var variantInventory = this.options[this.selectedIndex].getAttribute("data-inventory");
            var productBoxWrapper = this.parentElement.parentElement.parentElement;
            var productFormWrapper = this.parentElement.parentElement;
            var addToCartButtonEnableText = productBoxWrapper.querySelector(".btn-add-to-cart").getAttribute("data-atc-text");
            var addToCartButtonDisableText = productBoxWrapper.querySelector(".btn-add-to-cart").getAttribute("data-oos-text");
            if(variantAvailable == "true")
            {
                productBoxWrapper.querySelector(".btn-add-to-cart").removeAttribute("disabled", "disabled");
                productBoxWrapper.querySelector(".btn-add-to-cart").innerHTML = addToCartButtonEnableText;
                productBoxWrapper.querySelector(".btn-add-to-cart").style.display = "block";
            }
            else
            {
                productBoxWrapper.querySelector(".btn-add-to-cart").setAttribute("disabled", "disabled");
                productBoxWrapper.querySelector(".btn-add-to-cart").innerHTML = addToCartButtonDisableText;
                productBoxWrapper.querySelector(".btn-add-to-cart").style.display = "none";
            }
            var priceHtml = '';
            priceHtml +='<span>'+ Shopify.formatMoney(variantOriginalPrice, theme.settings.moneyFormat) +'</span>';
            if(variantIsSalePrice == "true")
            {
                priceHtml += '<del class="product__price-sale">'+ Shopify.formatMoney(variantSalePrice, theme.settings.moneyFormat) +'</del>';
            }
            if(priceHtml)
            {
                productBoxWrapper.querySelector(".js-product-price").innerHTML = priceHtml;
            }
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
            window.history.replaceState({path: newurl}, '', newurl);
        });
    }
    if(document.querySelector('.product-form .btn-add-to-cart'))
    {
        document.querySelector('.product-form .btn-add-to-cart').addEventListener('click', function(event) {
            event.preventDefault();
            var productForm = this.parentElement.parentElement;
            var variantId = "";
            if(productForm.querySelector(".js-actual-product-variants"))
            {
                variantId = productForm.querySelector(".js-actual-product-variants").value;
            }
            var quantity = 1;
            var OpenCart = true;
            if(variantId && quantity)
            {
                ajaxAddToCart(variantId, quantity, OpenCart);
            }
        });
    }
    
    var faqToggle = document.getElementsByClassName('.header-home .icn-menu')[0];
    if(document.querySelectorAll('.icn-menu'))
    {
        var faqContainers = document.querySelectorAll('.icn-menu'); 
        faqContainers.forEach(function(element){
            element.addEventListener('click', function () {
                if (document.querySelector('body').classList.contains('mobile-menu-open')) 
                {
                    document.querySelector('html').classList.remove('mobile-menu-open');
                    document.querySelector('body').classList.remove('mobile-menu-open');
                    if(document.querySelector('.header-home'))
                    {
                        document.querySelector('.header-home').classList.remove('sticky');
                    }
                    faqToggle.classList.remove('show');
                }
                else
                {
                    document.querySelector('html').classList.add('mobile-menu-open');
                    document.querySelector('body').classList.add('mobile-menu-open');
                    if(document.querySelector('.header-home'))
                    {
                        document.querySelector('.header-home').classList.add('sticky');
                    }
                    faqToggle.classList.add('show');
                }
            });
        }); 
    }

    var faqContainers = document.getElementsByClassName('closeSidebar')[0];
    var faqToggle = document.getElementsByClassName('sideBar')[0];
    if(faqContainers)
    {
        faqContainers.addEventListener('click', function () { 
            if (faqToggle.classList.contains('sideBar')) {
                document.querySelector('body').classList.remove('mobile-menu-open');
                faqToggle.classList.remove('show');
            }
        });
    }
    // header Side menu js End    
});

// Size Guide Js Start
if(document.querySelector('.size-guide-link')){
    var sizeGuideLink = document.getElementsByClassName('size-guide-link')[0];
    var faqToggle = document.getElementsByClassName('aside-size-guide')[0];
    var bodyClass = document.getElementsByClassName('product')[0];

    if(typeof sizeGuideLink != 'undefined'){
        sizeGuideLink.addEventListener('click', function () {
            if (faqToggle.classList.contains('aside-size-guide')) {
                faqToggle.classList.add('show');
                bodyClass.classList.add('overlay');
            }
        });
    }
}

if(document.querySelector('.close-size-guide')){
    var closeSizeGuide = document.getElementsByClassName('close-size-guide')[0];
    var faqToggle = document.getElementsByClassName('aside-size-guide')[0];
    var bodyClass = document.getElementsByClassName('product')[0];
    if(closeSizeGuide)
    {
        closeSizeGuide.addEventListener('click', function () {
            if (faqToggle.classList.contains('aside-size-guide')) {
                faqToggle.classList.remove('show');
                bodyClass.classList.remove('overlay');
            } 
        });        
    }
}
// Size Guide Js End

// Side Cart Js Start
if(document.querySelector('.cart-link'))
{
    var cartLink = document.querySelectorAll('.cart-link');
    for(i=0;i<=cartLink.length;i++)
    {
        if(typeof cartLink[i] != 'undefined')
        {
            cartLink[i].addEventListener('click', function (event) {
                event.preventDefault();
                if(document.querySelector('body').classList.contains('mobile-menu-open'))
                {
                    document.querySelector('#icn-menu-mobile').click();
                }
                ajaxCartCall(true);
            });
        }
    }
}

if(document.querySelector('.close-side-cart'))
{
    var closeSideCart = document.getElementsByClassName('close-side-cart')[0];
    if(closeSideCart)
    {
        closeSideCart.addEventListener('click', function () {          
            var sideCart = document.querySelector('.side-cart');
            var body = document.querySelector('body');
            body.classList.remove('overlay');
            sideCart.classList.remove('show');
        });        
    }
}
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.other-pages-header header.header'))
    {
        var othePagesHeader = document.querySelector('.other-pages-header header.header');
        var otherPagesHeight = document.querySelector('.other-pages-header header.header').offsetHeight + 10;
        var currentWindowScroll = window.pageYOffset;
        if(currentWindowScroll > 0)
        {
            othePagesHeader.classList.add("sticky");
        }
        else
        {
            othePagesHeader.classList.remove("sticky");
        }
        window.addEventListener('scroll', function() { 
            if(document.querySelector('body').classList.contains("overlay"))
            {

            }
            else
            {
                var currentWindowOnScroll = window.scrollY;
                if(currentWindowOnScroll > 0)
                {
                    othePagesHeader.classList.add("sticky");
                }
                else
                {
                    othePagesHeader.classList.remove("sticky");
                }
            }
        });
        window.onwheel = e => {
            if(document.querySelector('body').classList.contains("overlay"))
            {

            }
            else
            {
                var currentWindowOnScroll = window.pageYOffset;
                if(e.deltaY >= 0)
                {
                    if(currentWindowOnScroll > 0)
                    {
                        othePagesHeader.classList.add("sticky");
                    }
                    else
                    {
                        othePagesHeader.classList.remove("sticky");
                    }
                } 
                else 
                {
                    if(currentWindowOnScroll > otherPagesHeight)
                    {
                        
                    }
                    else
                    {
                        othePagesHeader.classList.remove("sticky");
                    }
                }
            }
            
        }
    }
    if(document.querySelector('body.index'))
    {
        var heroSection = document.querySelector('#main-home-hero');
        var heroSectionHeight = heroSection.offsetHeight;
        if(window.screen.width > 768)
        {
        }
        else
        {
            var othePagesHeader = document.querySelector('body.index .header-home');
            var otherPagesHeight = document.querySelector('body.index .header-home').offsetHeight + 10;
            window.addEventListener("scroll", function(){
                if(document.querySelector('body').classList.contains("overlay") || document.querySelector('body').classList.contains("mobile-menu-open"))
                {
                
                }
                else
                {
                    var currentWindowOnScroll = window.pageYOffset;
                    if(currentWindowOnScroll >= heroSectionHeight)
                    {
                        othePagesHeader.classList.add("sticky");
                    }
                    else
                    {
                        othePagesHeader.classList.remove("sticky");
                    }
                }
            });
        }
    }
});


// Reverse scroll header back to bottom js End

// blog page tabin js Start
function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
}

// collection page js Start
var el = document.querySelectorAll('.collection-page__content .collection-nav li');
for (let i = 0; i < el.length; i++) {
  el[i].onclick = function() {
    var c = 0;
    while (c < el.length) {
      el[c++].className = 'slide';
    }
    el[i].className = 'active';
  };
}
// collection page js Start

// Accordian js Start
let question = document.querySelectorAll(".question");

question.forEach((qsitem) => {
  qsitem.addEventListener("click", function (e) {
    //   store the .answer div containing the answer
    let sibling = qsitem.nextElementSibling;

    // Nested loop for removing active class from all and set answer height to 0
    question.forEach((item) => {
      item.nextElementSibling.style.height = "0px";
      //   remove class "active" except for the currently clicked item
      item != qsitem && item.parentNode.classList.remove("active");
    });
    //then toggle the "active" class of clicked item's parent ".qna"
    this.parentNode.classList.toggle("active");

    // set actual height for .answer div if .qna has the class "active"
    if (qsitem.parentNode.classList.contains("active")) {
      sibling.style.height = sibling.scrollHeight + "px";
    } else {
      sibling.style.height = "0px";
    }
  });
});
// Accordian js End

// Quentity Btn js Start
var input = document.querySelector('#qty');
var btnminus = document.querySelector('.qtyminus');
var btnplus = document.querySelector('.qtyplus');

if (input !== undefined && btnminus !== undefined && btnplus !== undefined && input !== null && btnminus !== null && btnplus !== null) {
	
	var min = Number(input.getAttribute('min'));
	var max = Number(input.getAttribute('max'));
	var step = Number(input.getAttribute('step'));

	function qtyminus(e) {
		var current = Number(input.value);
		var newval = (current - step);
		if(newval < min) {
			newval = min;
		} else if(newval > max) {
			newval = max;
		} 
		input.value = Number(newval);
		e.preventDefault();
	}

	function qtyplus(e) {
		var current = Number(input.value);
		var newval = (current + step);
		if(newval > max) newval = max;
		input.value = Number(newval);
		e.preventDefault();
	}
		
	btnminus.addEventListener('click', qtyminus);
	btnplus.addEventListener('click', qtyplus);
  
}
// Quentity Btn js End

// Animation js Start
const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;
    return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
};
const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;
    return (
        elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
};
const displayScrollElement = (element) => {
    element.classList.add("scrolled");
};
const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
};
const handleScrollAnimation = () => {
    if(document.querySelectorAll(".js-scroll"))
    {
        const scrollElements = document.querySelectorAll(".js-scroll");
        scrollElements.forEach((el) => {
            if (elementInView(el, 1.25)) {
                displayScrollElement(el);
            } else if (elementOutofView(el)) {
                hideScrollElement(el)
            }
        });
    }
}
window.addEventListener("scroll", () => {
    handleScrollAnimation();
});
window.addEventListener('load', function() {
    handleScrollAnimation();
    if(document.querySelector('.product-page__content .img-block .carousel'))
    {
        var flkty = new Flickity(".product-page__content .img-block .carousel", {
          pageDots: false,
          watchCSS: true,
          adaptiveHeight: true
        });
        flkty.resize();
    }
    if(document.querySelector('body.index'))
    {
        var heroSection = document.querySelector('#main-home-hero');
        var heroSectionHeight = heroSection.offsetHeight;
        if(window.screen.width > 768)
        {
            
        }
        else
        {
            setTimeout(function(){
                var othePagesHeader = document.querySelector('body.index .header-home');
                var otherPagesHeight = document.querySelector('body.index .header-home').offsetHeight + 10;
                window.addEventListener("scroll", function(){
                    if(document.querySelector('body').classList.contains("overlay") || document.querySelector('body').classList.contains("mobile-menu-open"))
                    {
                    
                    }
                    else
                    {
                        var currentWindowOnScroll = window.pageYOffset;
                        if(currentWindowOnScroll >= heroSectionHeight)
                        {
                            othePagesHeader.classList.add("sticky");
                        }
                        else
                        {
                            othePagesHeader.classList.remove("sticky");
                        }
                    }
                });
            }, 500);
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
   if(document.querySelector(".facets__wrapper .facets__disclosure"))
   {
       document.querySelectorAll('.facets__wrapper .facets__disclosure').forEach(selector => {
           var innerHeight = selector.querySelector('.facets__display').offsetHeight;
           selector.querySelector('.facets__display').style.height = "0px";
           selector.setAttribute("data-option-height", innerHeight+"px");
           selector.removeAttribute("open");
           selector.querySelector('.facets__summary').addEventListener('click', function(event) {
               var getHeight = this.parentElement.getAttribute("data-option-height");
               var getInnerHeight = this.parentElement.querySelector('.facets__display').offsetHeight;
               if(getInnerHeight > 0)
               {
                    this.parentElement.querySelector('.facets__display').style.height = "0px";
                    this.parentElement.classList.remove("active");
               }
               else
               {
                   this.parentElement.querySelector('.facets__display').style.height = getHeight;
                   this.parentElement.classList.add("active");
               }
           });
       });
   }
   if(document.querySelector(".custom-sorting-filter ul"))
   {
        var innerHeight = document.querySelector('.custom-sorting-filter ul').offsetHeight;
        document.querySelector('.custom-sorting-filter-title').setAttribute("data-option-height", innerHeight+"px");
        document.querySelector('.custom-sorting-filter ul').style.height = "0px";
        document.querySelector('.custom-sorting-filter-title').addEventListener('click', function(event) {
            event.preventDefault();
            var getHeight = this.getAttribute("data-option-height");
            var getInnerHeight = this.parentNode.querySelector('ul').offsetHeight;
            if(getInnerHeight > 0)
            {
                this.parentNode.querySelector('ul').style.height = "0px";
                this.classList.remove("active");
            }
            else
            {
               this.parentNode.querySelector('ul').style.height = getHeight;
               this.classList.add("active");
            }
        });
   }
   if(document.querySelector(".main-blog-link"))
   {
     var getArticleBlogLink = document.querySelector(".main-blog-link").getAttribute("data-blog-url");
     if(typeof getArticleBlogLink != "undefined" && getArticleBlogLink != null && getArticleBlogLink != "")
     {
        var otherPageLeftLink = document.querySelectorAll('.header__left-nav li');
        if(otherPageLeftLink)
        {
            otherPageLeftLink.forEach(selector => {
                if(selector.querySelector("a"))
                {
                    
                    var getHrefLink = selector.querySelector("a").getAttribute("href");
                    if(typeof getHrefLink != "undefined" && getHrefLink != null && getHrefLink != "")
                    {
                        if(getHrefLink == getArticleBlogLink)
                        {
                            selector.querySelector("a").classList.add('active');
                        }
                    }
                }
            });
        }
        var otherPageRightLink = document.querySelectorAll('.header__right-nav li');
        if(otherPageRightLink)
        {
            otherPageRightLink.forEach(selector => {
                if(selector.querySelector("a"))
                {
                    
                    var getHrefLink = selector.querySelector("a").getAttribute("href");
                    if(typeof getHrefLink != "undefined" && getHrefLink != null && getHrefLink != "")
                    {
                        if(getHrefLink == getArticleBlogLink)
                        {
                            selector.querySelector("a").classList.add('active');
                        }
                    }
                }
            });
        }
        var mobileMenuCenterLink = document.querySelectorAll('.center-link-content .center-link li');
        if(mobileMenuCenterLink)
        {
            mobileMenuCenterLink.forEach(selector => {
                if(selector.querySelector("a"))
                {
                    
                    var getHrefLink = selector.querySelector("a").getAttribute("href");
                    if(typeof getHrefLink != "undefined" && getHrefLink != null && getHrefLink != "")
                    {
                        if(getHrefLink == getArticleBlogLink)
                        {
                            selector.querySelector("a").classList.add('active');
                        }
                    }
                }
            });
        }
        var mobileMenuBottomLink = document.querySelectorAll('.bottom-link-content .bottom-link li');
        if(mobileMenuBottomLink)
        {
            mobileMenuBottomLink.forEach(selector => {
                if(selector.querySelector("a"))
                {
                    
                    var getHrefLink = selector.querySelector("a").getAttribute("href");
                    if(typeof getHrefLink != "undefined" && getHrefLink != null && getHrefLink != "")
                    {
                        if(getHrefLink == getArticleBlogLink)
                        {
                            selector.querySelector("a").classList.add('active');
                        }
                    }
                }
            });
        }
     }
   }
   
});